import { Component, Inject, OnInit } from "@angular/core";
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogRef,
} from "@angular/material/dialog";
import { ReportProvider } from "../../../../../../../../../shared/cw-backend/providers/application/report/report.provider";
import { PrintOsComponent } from "../print-os/print-os.component";

@Component({
    selector: "app-type-receipt",
    templateUrl: "./type-receipt.component.html",
    styleUrls: ["./type-receipt.component.scss"],
})
export class TypeReceiptComponent implements OnInit {
    pdfSrc = null;
    loadingReceipt: string | null = null;

    constructor(
        public dialogRef: MatDialogRef<TypeReceiptComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private reportprovider: ReportProvider,
        private _matDialog: MatDialog,
    ) {}

    ngOnInit() {}

    generateReceipt(type: string) {
        this.loadingReceipt = type;

        this.reportprovider
            .getPdfReceiptOS(this.data.id, type)
            .then((x) => {
                this.pdfSrc = x.pdf as string;

                const dialogRef = this._matDialog.open(PrintOsComponent, {
                    height: "100%",
                    width: "120%",
                    data: { pdf: this.pdfSrc, id: this.data.id, type: type },
                });

                dialogRef.afterClosed().subscribe(() => {
                    this.pdfSrc = null;
                });
            })
            .catch(() => {})
            .finally(() => {
                this.loadingReceipt = null;
            });
    }
}
